import { CheckoutState } from '../state';

export const getIsPaymentView = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname ===
    '/checkout-external/checkout';
